import * as React from 'react';
import { ActivityIcon } from 'lucide-react';
import { useTripStore } from 'pages/tracking-v2/trip-details-page/hooks';
import { Timeline } from 'components/ui/timeline';
import { Card, CardContent } from 'components/ui/card';
import { Formatter } from 'utils';

import { UserCircleICon, TimelineContainer, TimelineSkeletonCard } from './ui-kit';

type Props = React.ComponentProps<'div'>

export const ActivitiesTimeline = (props: Props) => {
  const { trip } = useTripStore();

  const timelineEvents = React.useMemo(() => {
    return trip?.activities?.sort((a, b) => {
      return new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
    })
  }, [trip?.activities]);

  if (!trip) {
    return (
      <TimelineContainer
        {...props}
        timelineIcon={<ActivityIcon />}
        timelineTitle={'Atividades'}
      >
        <Timeline className={'py-6'}>
          {Array.from({ length: 3 }).map((_, index) => (
            <TimelineSkeletonCard key={index} />
          ))}
        </Timeline>
      </TimelineContainer>
    );
  }

  return (
    <TimelineContainer
      {...props}
      timelineIcon={<ActivityIcon />}
      timelineTitle={'Atividades'}
    >
      <Timeline className={'py-6 flex-1'}>
        {timelineEvents?.map((event) => (
          <Card key={event.id} className={'shadow-none w-full max-w-[460px]'}>
            <CardContent className={'pt-6'}>
              <div className={'flex items-center gap-2 mb-4'}>
                <UserCircleICon />
                <span className={'font-GilroySemibold text-[14px] text-black'}>{event?.user?.name || 'Sistema'}</span>
              </div>
              <p className={'text-gray-600 text-xs'}>{event.description}</p>
              <p className={'text-gray-400 text-xs mt-4'}>
                {Formatter.date(event.createdAt, { format: 'dd/MM/yyyy HH:mm' })}
              </p>
            </CardContent>
          </Card>
        ))}
      </Timeline>
    </TimelineContainer>
  );
}
